import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import moment from 'moment';

import Form from '@appComponents/ReduxFormControls';
import {getTodayDate, getEndOfTodayDate} from '@utils/date';

const DATE_FORMAT = 'YYYY-MM-DD HH:mm';
const TIME_FORMAT = 'HH:mm';

const safeDateMoment = (...args) => {
    for (const val of args) {
        if (moment.isMoment(val) && val.isValid()) {
            return val.toDate();
        }

        if (val && 'string' === typeof val) {
            const d = new Date(val);

            if (!isNaN(d.getTime())) return d;
        }

        if (val instanceof Date && !isNaN(val.getTime())) {

            return val;
        }
    }

    return undefined;
};

export const DateRangeFilter = ({
    loading,
    filters,
    restoreFilterDateValues,
    onChange,
    dateConfig = {},
    showTime = true,
    defaultFromDate = getTodayDate(),
    defaultToDate = getEndOfTodayDate(),
    configuration = {},
}) => {
    const baseConfig = {
        ...(showTime && {calendarClassName: 'filterDatepicker'}),
        dateFormat: showTime ? DATE_FORMAT : 'YYYY-MM-DD',
        shouldCloseOnSelect: !showTime,
        portalId: 'root',
        ...(showTime ? {
            showTimeSelect: true,
            timeFormat: TIME_FORMAT,
            timeIntervals: 5,
        } : {
            showTimeSelect: false,
        }),
    };

    const fieldClassName = showTime ? '--minimalWidth --datetimeWithoutSeconds' : undefined;

    return (
        <>
            <Field
                component={Form.ReduxInput}
                disabled={loading}
                loading={loading}
                name='from'
                className={fieldClassName}
                configuration={{
                    ...baseConfig,
                    onChange: (date) => onChange?.(date, 'from'),
                    maxDate: safeDateMoment(dateConfig.fromMaxDate, dateConfig.fromMaxDateDefault, defaultFromDate),
                    ...configuration,
                }}
                placeholder='From...'
                setValue={restoreFilterDateValues(filters, 'from', defaultFromDate)}
                defaultValue={defaultFromDate}
                type='date'
            />
            <Field
                component={Form.ReduxInput}
                disabled={loading}
                loading={loading}
                name='to'
                className={fieldClassName}
                configuration={{
                    ...baseConfig,
                    onChange: (date) => onChange?.(date, 'to'),
                    minDate: safeDateMoment(dateConfig.toMinDate, dateConfig.toMinDateDefault, defaultToDate),
                    ...configuration,
                }}
                placeholder='To...'
                setValue={restoreFilterDateValues(filters, 'to', defaultToDate)}
                defaultValue={defaultToDate}
                type='date'
            />
        </>
    );
};

DateRangeFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterDateValues: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    dateConfig: PropTypes.shape({
        fromMaxDate: PropTypes.object,
        fromMaxDateDefault: PropTypes.object,
        fromMaxTime: PropTypes.object,
        toMinDate: PropTypes.object,
        toMinDateDefault: PropTypes.object,
        toMinTime: PropTypes.object,
    }),
    showTime: PropTypes.bool,
    defaultFromDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    defaultToDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    configuration: PropTypes.object,
};
